import React from 'react';

// Encapsulado para depois poder substituir pelo useDispatch() das versões mais atuais do redux quando for atualizada a lib
export default function useReduxDispatch() {
  return window.ReduxStore.dispatch;
}
